import { GenericBackendResponse } from '../../genericBackendResponse';

export interface PayfitToken {
	id: string;
	createdAt: string;
	updatedAt: string;
	companyId: string;
	payfitCompanyId: string;
	accessToken: string;
	scope: string;
	active: boolean;
	lastCheckedAt: string;
}

export type GetActualTokenResponse = GenericBackendResponse<PayfitToken | string>;

const getActualToken = async (
	token: string,
	companyId?: string
): Promise<GetActualTokenResponse> => {
	// Build URL with optional companyId query parameter
	let url = `${process.env.REACT_APP_BASE_API}/thirdparty/payfit/actual-token`;
	if (companyId) {
		url += `?companyId=${encodeURIComponent(companyId)}`;
	}

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	return response.json();
};

export default getActualToken;
